










































































































































import Vue, { VueConstructor } from 'vue';
import {
	mapActions,
	mapGetters,
	mapMutations,
	mapState,
} from 'vuex';
import AdditionalFieldsForm from '@/components/AdditionalFieldsForm.vue';
import ReservationFppSelector from '@/components/ReservationFppSelector.vue';
import PersonalForm from '@/components/PersonalForm.vue';
import ReservationCustomerSummary from '@/components/ReservationCustomerSummary.vue';
import FormInput from '@/components/ui/FormInput.vue';
import MarkdownText from '@/components/ui/MarkdownText.vue';
import VehiclesForm from '@/components/VehiclesForm.vue';
import ReservationStep from '@/types/reservationStep';
import TransitionExpand from '@/components/TransitionExpand.vue';
import Customer from '@/models/Customer';
import Reservation from '@/models/Reservation';
import ReservationFields from '@/models/ReservationFields';
import Vehicle from '@/models/Vehicle';
import { getOrArray } from '@/utilities/helpers';

export default Vue.extend({
	name: 'ReservationCustomerDetails',
	inject: ['$validator'],
	components: {
		AdditionalFieldsForm,
		FormInput,
		MarkdownText,
		ReservationFppSelector,
		PersonalForm,
		ReservationCustomerSummary,
		TransitionExpand,
		VehiclesForm,
	},

	data() {
		return {
			model: new Customer(),
			Step: ReservationStep,
		};
	},

	computed: {
		...mapState('reservation', ['reservation', 'step']),
		...mapGetters(['customer', 'isLoggedIn']),
		...mapGetters('location', ['location', 'settings']),
		...mapGetters('reservation', {
			isExistingReservation: 'isExistingReservation',
			reservationCustomer: 'customer',
		}),

		customerFromLocation(): boolean {
			return this.$store.getters['reservation/customerFromLocation'];
		},

		isLoading(): boolean {
			return this.$store.state.isLoading;
		},

		reservationFields(): ReturnType<typeof ReservationFields> {
			return ReservationFields(this.settings);
		},
		allowCustomerEdit(): boolean {
			return (this.settings && this.settings.allow_registration_edit);
		},
	},

	watch: {
		model: {
			deep: true,
			handler(value: Customer) {
				this.setCustomer(value);
			},
		},
	},

	created() {
		this.model = new Customer({
			...this.customer,
			...this.reservationCustomer,
			code: this.customer.code,
		});
		this.reservation.email_requested = true;
	},

	methods: {
		...mapMutations('reservation', ['setCustomer', 'setStep', 'setVehicle']),
		...mapActions('reservation', ['validateCustomer']),

		uxAction() {
			const vehicle = this.$store.state.reservation.reservation.vehicle;
			const apiCustomer = {
				cell_phone: this.model.cell_phone !== '' ? this.model.cell_phone : this.customer.cell_phone,
				work_phone: this.model.work_phone !== '' ? this.model.work_phone : this.customer.work_phone,
				company_name: this.model.company_name !== '' ? this.model.company_name : this.customer.company_name,
				address1: this.model.address1 !== '' ? this.model.address1 : this.customer.address1,
				address2: this.model.address2 !== '' ? this.model.address2 : this.customer.address2,
				state: this.model.state !== '' ? this.model.state : this.customer.state,
				city: this.model.city !== '' ? this.model.city : this.customer.city,
				zip: this.model.zip !== '' ? this.model.zip : this.customer.zip,
				customer: this.model.customer !== 0 ? this.model.customer : this.customer.customer,
				first_name: this.model.first_name !== '' ? this.model.first_name : this.customer.first_name,
				last_name: this.model.last_name !== '' ? this.model.last_name : this.customer.last_name,
				email: this.model.email !== '' ? this.model.email : this.customer.email,
				number_of_passengers: this.model.number_of_passengers !== 0 ? this.model.number_of_passengers : this.customer.number_of_passengers,
				vehicle_license: vehicle.license,
				vehicle_make: vehicle.make,
				vehicle_model: vehicle.model,
				vehicle_color: vehicle.color,
				vehicle_state: vehicle.state,
				email_receipt: this.reservation.email_requested ? this.reservation.email_requested : this.customer.email_receipt,
				newsletter_opt_in: this.model.newsletter_opt_in ? this.model.newsletter_opt_in : this.customer.newsletter_opt_in,
				text_opt_in: this.model.text_opt_in ? this.model.text_opt_in : this.customer.text_opt_in,
			}
			this.$store.dispatch('googleEvents/customerDetailsSubmitted', {
				customerDetails: apiCustomer,
			});
		},

		updateVehicle(vehicle: Vehicle) {
			this.setVehicle(vehicle);
		},

		async submit() {
			console.log('Submitting Customer Details...');
			if (!await this.$validator.validate()) {
				return;
			}

			await this.validateCustomer({
				customer: this.reservationCustomer,
				vehicle: this.reservation.vehicle,
				location: this.location.codeID as string,
			}).catch(({ response }: any) => {
				getOrArray('data.errors', response).forEach((error: any) => {
					this.errors.add({ field: error.name, msg: error.text });
				});
			});

			if (this.errors.any()) {
				return;
			}

			this.setStep(this.Step.Services);
		},
	},
});
